import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { sitekey: String }

  connect() {
    if (typeof turnstile !== "undefined") {
      this.renderWidget()
    } else {
      this.pollForTurnstile()
    }
  }

  disconnect() {
    if (this.widgetId) {
      try { turnstile.remove(this.widgetId) } catch (_) {}
      this.widgetId = null
    }
    if (this.pollTimer) {
      clearInterval(this.pollTimer)
    }
  }

  renderWidget() {
    if (this.widgetId) return

    this.widgetId = turnstile.render(this.element, {
      sitekey: this.sitekeyValue
    })
  }

  pollForTurnstile() {
    let attempts = 0
    this.pollTimer = setInterval(() => {
      attempts++
      if (typeof turnstile !== "undefined") {
        clearInterval(this.pollTimer)
        this.renderWidget()
      } else if (attempts > 50) {
        clearInterval(this.pollTimer)
      }
    }, 100)
  }
}
